// extracted by mini-css-extract-plugin
module.exports = {"root":"_8da2e1c6","logoWrapper":"_8801f610","logo":"_2f4f4034"};